export const errorButtonText = 'Return Home'
export const pageNotFoundHeader = 'Oops!'
export const pageNotFoundText = 'We cannot find that page.'
export const pageNotFoundAltText = 'Page Not Found'
export const unauthorizedText = 'You don\'t have permission to access this resource.'
export const unauthorizedHeader = 'Forbidden'
export const unauthorizedAltText = 'Unauthorized'